import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import GreenpapersPage from "@/pages/GreenpapersPage";
import GreenpaperDetailPage from "@/pages/GreenpaperDetailPage";
import AboutPage from "@/pages/AboutPage";
import ProductsPage from "@/pages/ProductsPage";
import EcosystemPage from "@/pages/EcosystemPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import ServicesPage from "@/pages/ServicesPage";
import MarketplacePage from "@/pages/MarketplacePage";
import ChecklistPage from "@/pages/ChecklistPage";
import DecisionTreePage from "@/pages/DecisionTreePage";
import CarpetCardPage from "@/pages/CarpetCardPage";
import SampleLibraryPage from "@/pages/SampleLibraryPage";
import ContactPage from "@/pages/ContactPage";
import CheckoutSuccessPage from "@/pages/CheckoutSuccessPage";
import LegalPage from "@/pages/LegalPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import { Toaster } from "@/components/ui/sonner";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function PostHogGuard() {
  const { pathname } = useLocation();
  useEffect(() => {
    try {
      const sensitive = /^\/(checkout|admin)/.test(pathname || "");
      if (window.posthog && window.posthog.stopSessionRecording && sensitive) {
        window.posthog.stopSessionRecording();
      } else if (window.posthog && window.posthog.startSessionRecording && !sensitive) {
        window.posthog.startSessionRecording();
      }
    } catch (e) {}
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <PostHogGuard />
        <Routes>
          <Route path="/" element={<Layout><HomePage /></Layout>} />
          <Route path="/greenpapers" element={<Layout><GreenpapersPage /></Layout>} />
          <Route path="/greenpapers/category/:slug" element={<Layout><GreenpapersPage /></Layout>} />
          <Route path="/greenpapers/:slug" element={<Layout><GreenpaperDetailPage /></Layout>} />
          <Route path="/products" element={<Layout><ProductsPage /></Layout>} />
          <Route path="/ecosystem" element={<Layout><EcosystemPage /></Layout>} />
          <Route path="/products/:slug" element={<Layout><ProductDetailPage /></Layout>} />
          <Route path="/checkout" element={<Navigate to="/products/low-tox-home-blueprint" replace />} />
          <Route path="/checkout/success" element={<Layout><CheckoutSuccessPage /></Layout>} />
          <Route path="/services" element={<Layout><ServicesPage /></Layout>} />
          <Route path="/sample-library" element={<Layout><SampleLibraryPage /></Layout>} />
          <Route path="/marketplace" element={<Layout><MarketplacePage /></Layout>} />
          <Route path="/resources/quick-start-checklist" element={<Layout><ChecklistPage /></Layout>} />
          <Route path="/resources/cumulative-exposure-decision-tree" element={<Layout><DecisionTreePage /></Layout>} />
          <Route path="/resources/carpet-keep-vs-replace" element={<Layout><CarpetCardPage /></Layout>} />
          <Route path="/about" element={<Layout><AboutPage /></Layout>} />
          <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
          <Route path="/legal/:page" element={<Layout><LegalPage /></Layout>} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<AdminDashboardPage />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
